// src/index.ts
import { BulletList } from "@tiptap/extension-list";
import { BulletList as BulletList2 } from "@tiptap/extension-list";
var index_default = BulletList;
export {
  BulletList2 as BulletList,
  index_default as default
};
//# sourceMappingURL=index.js.map